import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import {
  VaultMenuAccessService,
  userIsSuperadminFromSession,
} from '@nebula/shared-vault/data-access';
import { map } from 'rxjs';
import { VaultAccessDeniedComponent } from '@nebula-shared/ui';

@Component({
  selector: 'app-vault-access-denied-page',
  standalone: true,
  imports: [CommonModule, VaultAccessDeniedComponent],
  template: `
    <section class="vault-access-denied-page">
      <app-vault-access-denied [moduleLabel]="moduleLabel()" />
    </section>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
        overflow: hidden;
      }

      .vault-access-denied-page {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultAccessDeniedPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly menuAccess = inject(VaultMenuAccessService);

  readonly moduleLabel = toSignal(
    this.route.queryParamMap.pipe(map((params) => params.get('label')?.trim() || 'este módulo')),
    { initialValue: 'este módulo' },
  );

  ngOnInit(): void {
    if (userIsSuperadminFromSession()) {
      const from = this.route.snapshot.queryParamMap.get('from')?.trim();
      void this.router.navigateByUrl(from || '/layout/vault/dashboard');
      return;
    }

    const from = this.route.snapshot.queryParamMap.get('from')?.trim();
    if (from && !this.menuAccess.shouldBlockAccess(from)) return;

    this.menuAccess.notifyModuleViewAccessDenied(this.moduleLabel(), from || undefined);
  }
}
